import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import Swal from "sweetalert2";
import fondo6 from "../../assets/images/fondo6.jpg";

const InscripcionesRegistradas = () => {
  const [inscripciones, setInscripciones] = useState([]);
  const API = process.env.REACT_APP_API_URL;

  const fetchInscripciones = async () => {
    try {
      const response = await fetch(`${API}/api/inscripciones/todas`);
      if (!response.ok) throw new Error("Error al obtener inscripciones");
      const data = await response.json();
      setInscripciones(data);
    } catch (error) {
      Swal.fire("❌ Error", error.message, "error");
    }
  };

  const eliminarInscripcion = async (id) => {
    const confirmacion = await Swal.fire({
      title: "¿Eliminar inscripción?",
      text: "Esta acción no se puede deshacer.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sí, eliminar",
      cancelButtonText: "Cancelar",
    });

    if (!confirmacion.isConfirmed) return;

    try {
      const res = await fetch(`${API}/api/inscripciones/eliminar/${id}`, {
        method: "DELETE",
      });

      if (!res.ok) throw new Error("No se pudo eliminar");

      await fetchInscripciones();
      Swal.fire("✅ Eliminado", "Inscripción eliminada correctamente", "success");
    } catch (error) {
      Swal.fire("❌ Error", error.message, "error");
    }
  };

  useEffect(() => {
    fetchInscripciones();
  }, []);

  return (
    <main
      className="min-h-screen p-6"
      style={{
        backgroundImage: `url(${fondo6})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundAttachment: "fixed",
      }}
    >
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        className="bg-white bg-opacity-95 rounded-3xl shadow-2xl p-10 max-w-7xl mx-auto"
      >
        <h2 className="text-4xl font-bold text-green-900 mb-6 text-center">
          Inscripciones Registradas
        </h2>

        <div className="overflow-x-auto">
          <table className="w-full border-collapse table-auto">
            <thead>
              <tr className="bg-green-700 text-white text-left">
                <th className="p-3">ID ESPE</th>
                <th className="p-3">Nombre Completo</th>
                <th className="p-3">Correo</th>
                <th className="p-3">Celular</th>
                <th className="p-3">Carrera</th>
                <th className="p-3">Nivel</th>
                <th className="p-3">Acción</th>
              </tr>
            </thead>
            <tbody>
              {inscripciones.length > 0 ? (
                inscripciones.map((item, index) => (
                  <tr key={index} className="border-b hover:bg-gray-100">
                    <td className="p-3">{item.IdEspe}</td>
                    <td className="p-3">
                      {item.PrimerNombre} {item.SegundoNombre} {item.ApellidoPaterno} {item.ApellidoMaterno}
                    </td>
                    <td className="p-3">{item.Correo}</td>
                    <td className="p-3">{item.Celular}</td>
                    <td className="p-3">{item.Carrera}</td>
                    <td className="p-3">{item.NivelSemestre}</td>
                    <td className="p-3">
                      <button
                        onClick={() => eliminarInscripcion(item.Id)}
                        className="bg-red-600 hover:bg-red-700 text-white px-2 py-1 rounded text-sm"
                      >
                        Eliminar
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="7" className="text-center py-4 text-gray-500">
                    No se han registrado inscripciones aún.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </motion.div>
    </main>
  );
};

export default InscripcionesRegistradas;